var voted_users_rtlignore_default = {
  "container": "z9ch2",
  "webview": "ytcmt",
  "avatar_list": "Tq5GV",
  "avatar": "bxlS8",
  "user_avatar": "pzVJH",
  "modal": "I-IpE",
  "voted_users_modal": "Z6lpT",
  "overlay": "foCjl",
  "user_card": "kEPDT",
  "user_name": "OT4TI",
  "voted_users_modal_header": "_9xg19",
  "cta": "gVU80",
  "close_icon": "kcVE0",
  "title": "ZznrM",
  "member_list_container": "TJplG",
  "member_list": "-WMCL",
  "loader": "Dvcan",
  "anonymous_counter": "BWfMM",
  "spinner": "Vx2fy",
  "spin": "SNuqL"
};
export {
  voted_users_rtlignore_default as default
};
//# sourceMappingURL=voted-users.rtlignore-scss.js.map
